import { DOCUMENT } from '@angular/common';
import { Inject, Injectable, Renderer2, RendererFactory2 } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DotcmsSeoSchemaService {
  private renderer: Renderer2;

  constructor(@Inject(DOCUMENT) private doc: Document, private rendererFactory: RendererFactory2) {
    this.renderer = this.rendererFactory.createRenderer(null, null);
  }

  setContentPageSchemaData(schema: unknown) {
    if (schema) {
      const json = JSON.stringify(schema);

      // Create <script> tag
      const script = this.renderer.createElement('script');
      this.renderer.setAttribute(script, 'type', 'application/ld+json');
      script.textContent = json;

      // Remove old structured data if already exists
      const existing = this.doc.head.querySelector('script[type="application/ld+json"]');
      if (existing) {
        this.renderer.removeChild(this.doc.head, existing);
      }

      // Append new structured data
      this.renderer.appendChild(this.doc.head, script);
    }
  }
}
